import { render, staticRenderFns } from "./CheckoutNotifyPage.vue?vue&type=template&id=ded5909a&scoped=true"
import script from "./CheckoutNotifyPage.vue?vue&type=script&lang=js"
export * from "./CheckoutNotifyPage.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNotifyPage.vue?vue&type=style&index=0&id=ded5909a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5909a",
  null
  
)

export default component.exports